import type { ReactNode } from 'react'
import type { Permission } from './permissions'
import { usePermissions } from './usePermissions'

interface CanProps {
  /** Bitta huquq yoki ro'yxat. Ro'yxat berilsa KAMIDA BITTASI yetarli. */
  permission: Permission | readonly Permission[]
  children: ReactNode
  /** Huquq bo'lmasa nima ko'rsatilsin. Standart — hech narsa. */
  fallback?: ReactNode
}

/**
 * Huquqqa qarab bolalarni ko'rsatadi.
 *
 * `{can('x') && <Button/>}` bilan bir xil ish qiladi, lekin bir nechta huquq
 * kerak bo'lganda va `fallback` bilan o'qishga osonroq.
 */
export function Can({ permission, children, fallback = null }: CanProps) {
  const { canAny } = usePermissions()
  // `typeof === 'string'` bilan tekshiramiz, `Array.isArray` bilan emas:
  // ikkinchisi TypeScript'da `readonly` massivni `any[]` ga toraytiradi va
  // tip xavfsizligi shu yerda jimgina yo'qoladi
  const list: readonly Permission[] = typeof permission === 'string' ? [permission] : permission
  return <>{canAny(...list) ? children : fallback}</>
}
